class CountrySuggestion extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.initElements();
		this.open();
		this.initEvents();
	}
	initElements() {
		this.closeButton = this.querySelector("[data-country-suggestion-close-button]")
	}

	open() {
		this.popupFlag = this.getCookie("countryPopupFlagUd");
		this.popupBeClosed = this.getCookie("popupBeClosedUd");
		if (!this.popupFlag){
			document.addEventListener("initCountryData", () => {
				this.open();
			})

			return null;
		}

		if (this.popupBeClosed == "true") {
			return null;
		}

		if (this.popupFlag == "true") {
			this.classList.add("open");
		}
	}

	initEvents() {
		if (this.closeButton) {
			this.closeButton.addEventListener("click", () => {
				this.classList.remove("open");
				document.cookie = `popupBeClosedUd=${true}; path=/; max-age=2592000`;
			})
		}
	}

	getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}
}

if (!customElements.get("country-suggestion")) {
	customElements.define("country-suggestion", CountrySuggestion)
}